import { Image } from "antd";
import React from "react";
import "./priceCalculator.css";

// Helper function to format numbers with commas and 2 decimal places
const formatCurrency = (amount) => {
  return parseFloat(amount).toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

export const PriceCalculatorItemMobile = ({
  postedDate,
  templateName,
  totalAmount,
  MoreActions,
  handleNavigation,
  items,
}) => {
  const foreignItem = items?.find((item) => item.currency !== "INR");
  const exchangeRate = parseFloat(foreignItem?.exchangeRate) || 1;
  const totalAmountForeign = totalAmount / exchangeRate;
  const currencyType = foreignItem ? foreignItem?.currency : "INR";
  const calculationItem = items?.[0];
  const noOfUnits = calculationItem?.noOfUnits || 1;
  const pricePerUnitINR = totalAmount / noOfUnits;
  const pricePerUnitForeign = totalAmountForeign / noOfUnits;

  return (
    <div
      className="price-calculator-item-mobile gx-pointer gx-border-bottom"
      onClick={handleNavigation}
    >
      <div className="item-content">
        <div className="item-top-row">
          <div className="item-template-name">{templateName}</div>
          
          <div className="price-row">
            <span className="price-label">Total Price Per Unit({currencyType}):</span>
            <span className="price-value">
              {exchangeRate === 1 ? formatCurrency(pricePerUnitINR) : formatCurrency(pricePerUnitForeign)}
            </span>
          </div>
          
          <div className="price-row">
            <span className="price-label">Total Price({currencyType}):</span>
            <span className="price-value">
              {exchangeRate === 1 ? formatCurrency(totalAmount) : formatCurrency(totalAmountForeign)}
            </span>
          </div>

          <div className="item-bottom-row">
            <div className="item-posted-date">Created At {postedDate}</div>
            <div className="item-actions">{MoreActions && <MoreActions />}</div>
          </div>
        </div>
      </div>
    </div>
  );
};